module.exports = __webpack_public_path__ + "img/t5-salmon.48bddfa9.png";